// One redress route for a signed-in customer (owner, 9 Oct): whatever form
// they write in (help widget, Support page, Contact page), the message goes
// into their support chat, where the assistant answers or hands over to a
// person, and every reply shows. HelpWidget listens for this event.
export const OPEN_SUPPORT_CHAT_EVENT = 'kanfy:open-support-chat';

/** Open the help widget on the Chat tab, optionally sending `message` there. */
export function openSupportChat(message?: string): void {
  window.dispatchEvent(new CustomEvent(OPEN_SUPPORT_CHAT_EVENT, { detail: { message } }));
}

// Phones have no floating Help button (it covered content: prices, chips,
// form fields); the header menu and the Profile pages open the panel instead.
export const OPEN_HELP_EVENT = 'kanfy:open-help';

/**
 * Open the help widget on its default tab (Chat when signed in, else Quick
 * Help). False when no widget is mounted to answer (it is left off some
 * routes): the caller then goes to the Support page instead.
 */
export function openHelp(): boolean {
  // The widget cancels the event to say it opened.
  return !window.dispatchEvent(new CustomEvent(OPEN_HELP_EVENT, { cancelable: true }));
}

/** A form's subject and body as one chat message. */
export function chatMessageFromForm(subject: string | null | undefined, body: string): string {
  const s = (subject ?? '').trim();
  const b = body.trim();
  return s ? `${s}\n\n${b}` : b;
}
